function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useRef } from "react";
import classNames from "classnames";
import { useSpring, animated } from "@react-spring/web";
import { withNativeProps } from "../../utils/with-native-props";
// import type { NativeProps } from "../../typing/native-props";
import { usePropsValue } from "../../utils/use-props-value";
import { bound } from "../../utils/bound";
import { useThrottleFn, useIsomorphicLayoutEffect } from "ahooks";
import { useMutationEffect } from "../../utils/use-mutation-effect";
import { useResizeEffect } from "../../utils/use-resize-effect";
import { mergeProps } from "../../utils/with-default-props";
import { useIsomorphicUpdateLayoutEffect } from "../../utils/use-isomorphic-update-layout-effect";
import { ShouldRender } from "../../utils/should-render";
import { traverseReactNode } from "../../utils/traverse-react-node";
var classPrefix = "tc-tabs";
export var Tab = function Tab() {
  return null;
};
var defaultProps = {
  activeLineMode: "fixed",
  stretch: true,
  showSubscript: true
};
export var Tabs = function Tabs(p) {
  var _a;
  var props = mergeProps(defaultProps, p);
  var tabListContainerRef = useRef(null);
  var activeLineRef = useRef(null);
  var keyToIndexRecord = {};
  var firstActiveKey = null;
  var panes = [];
  traverseReactNode(props.children, function (child, index) {
    if (! /*#__PURE__*/React.isValidElement(child)) return;
    var key = child.key;
    if (typeof key !== "string") return;
    if (index === 0) {
      firstActiveKey = key;
    }
    // @ts-ignore
    var length = panes.push(child);
    keyToIndexRecord[key] = length - 1;
  });
  var _usePropsValue = usePropsValue({
      value: props.activeKey,
      defaultValue: (_a = props.defaultActiveKey) !== null && _a !== void 0 ? _a : firstActiveKey,
      onChange: function onChange(v) {
        var _a;
        if (v === null) return;
        (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, v);
      }
    }),
    _usePropsValue2 = _slicedToArray(_usePropsValue, 2),
    activeKey = _usePropsValue2[0],
    setActiveKey = _usePropsValue2[1];
  var _useSpring = useSpring(function () {
      return {
        x: 0,
        width: 0,
        config: {
          tension: 300,
          clamp: true
        }
      };
    }),
    _useSpring2 = _slicedToArray(_useSpring, 2),
    _useSpring2$ = _useSpring2[0],
    x = _useSpring2$.x,
    width = _useSpring2$.width,
    api = _useSpring2[1];
  var _useSpring3 = useSpring(function () {
      return {
        scrollLeft: 0,
        config: {
          tension: 300,
          clamp: true
        }
      };
    }),
    _useSpring4 = _slicedToArray(_useSpring3, 2),
    scrollLeft = _useSpring4[0].scrollLeft,
    scrollApi = _useSpring4[1];
  var _useSpring5 = useSpring(function () {
      return {
        leftMaskOpacity: 0,
        rightMaskOpacity: 0,
        config: {
          clamp: true
        }
      };
    }),
    _useSpring6 = _slicedToArray(_useSpring5, 2),
    _useSpring6$ = _useSpring6[0],
    leftMaskOpacity = _useSpring6$.leftMaskOpacity,
    rightMaskOpacity = _useSpring6$.rightMaskOpacity,
    maskApi = _useSpring6[1];
  function animate() {
    var immediate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var container = tabListContainerRef.current;
    if (!container) return;
    var activeIndex = keyToIndexRecord[activeKey];
    if (activeIndex === undefined) {
      api.start({
        x: 0,
        width: 0,
        immediate: true
      });
      return;
    }
    var activeLine = activeLineRef.current;
    if (!activeLine) return;
    var activeTabWrapper = container.children.item(activeIndex + 1);
    var activeTab = activeTabWrapper.children.item(0);
    var activeTabLeft = activeTab.offsetLeft;
    var activeTabWidth = activeTab.offsetWidth;
    var activeTabWrapperLeft = activeTabWrapper.offsetLeft;
    var activeTabWrapperWidth = activeTabWrapper.offsetWidth;
    var containerWidth = container.offsetWidth;
    var containerScrollWidth = container.scrollWidth;
    var containerScrollLeft = container.scrollLeft;
    var activeLineWidth = activeLine.offsetWidth;
    var xx = 0;
    var widthActive = 0;
    if (props.activeLineMode === "auto") {
      xx = activeTabLeft;
      widthActive = activeTabWidth;
    } else if (props.activeLineMode === "full") {
      xx = activeTabWrapperLeft;
      widthActive = activeTabWrapperWidth;
    } else {
      xx = activeTabLeft + (activeTabWidth - activeLineWidth) / 2;
    }
    api.start({
      x: xx,
      width: widthActive,
      immediate: immediate
    });
    var maxScrollDistance = containerScrollWidth - containerWidth;
    if (maxScrollDistance <= 0) return;
    var nextScrollLeft = bound(activeTabLeft - (containerWidth - activeTabWidth) / 2, 0, containerScrollWidth - containerWidth);
    scrollApi.start({
      scrollLeft: nextScrollLeft,
      from: {
        scrollLeft: containerScrollLeft
      },
      immediate: immediate
    });
  }
  useIsomorphicLayoutEffect(function () {
    animate(!x.isAnimating);
  }, []);
  useIsomorphicUpdateLayoutEffect(function () {
    animate();
  }, [activeKey]);
  useResizeEffect(function () {
    animate(!x.isAnimating);
  }, tabListContainerRef);
  useMutationEffect(function () {
    animate(!x.isAnimating);
  }, tabListContainerRef, {
    subtree: true,
    childList: true,
    characterData: true
  });
  var _useThrottleFn = useThrottleFn(function () {
      var immediate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var container = tabListContainerRef.current;
      if (!container) return;
      var scrollLeftContainer = container.scrollLeft;
      var showLeftMask = scrollLeftContainer > 0;
      var showRightMask = scrollLeftContainer + container.offsetWidth < container.scrollWidth;
      maskApi.start({
        leftMaskOpacity: showLeftMask ? 1 : 0,
        rightMaskOpacity: showRightMask ? 1 : 0,
        immediate: immediate
      });
    }, {
      wait: 100,
      trailing: true,
      leading: true
    }),
    updateMask = _useThrottleFn.run;
  useIsomorphicLayoutEffect(function () {
    updateMask(true);
  }, []);
  return withNativeProps(props, /*#__PURE__*/React.createElement("div", {
    className: classPrefix
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-header")
  }, /*#__PURE__*/React.createElement(animated.div, {
    className: classNames("".concat(classPrefix, "-header-mask"), "".concat(classPrefix, "-header-mask-left")),
    style: {
      opacity: leftMaskOpacity
    }
  }), /*#__PURE__*/React.createElement(animated.div, {
    className: classNames("".concat(classPrefix, "-header-mask"), "".concat(classPrefix, "-header-mask-right")),
    style: {
      opacity: rightMaskOpacity
    }
  }), /*#__PURE__*/React.createElement(animated.div, {
    className: "".concat(classPrefix, "-tab-list ").concat(props.tabsClassName || ""),
    style: props.tabsStyle,
    ref: tabListContainerRef,
    scrollLeft: scrollLeft,
    onScroll: updateMask
  }, props.showSubscript && /*#__PURE__*/React.createElement(animated.div, {
    ref: activeLineRef,
    className: "".concat(classPrefix, "-tab-line"),
    style: {
      width: props.activeLineMode === "fixed" ? "var(--fixed-active-line-width, 20px)" : width,
      x: x
    }
  }), panes.map(function (pane) {
    var _classNames2;
    return withNativeProps(pane.props, /*#__PURE__*/React.createElement("div", {
      key: pane.key,
      className: classNames("".concat(classPrefix, "-tab-wrapper"), _defineProperty({}, "".concat(classPrefix, "-tab-wrapper-stretch"), props.stretch))
    }, /*#__PURE__*/React.createElement("div", {
      onClick: function onClick() {
        var key = pane.key;
        if (pane.props.disabled) return;
        if (key === undefined || key === null) {
          return;
        }
        setActiveKey(key.toString());
      },
      className: classNames("".concat(classPrefix, "-tab"), (_classNames2 = {}, _defineProperty(_classNames2, "".concat(classPrefix, "-tab-active"), pane.key === activeKey), _defineProperty(_classNames2, "".concat(classPrefix, "-tab-disabled"), pane.props.disabled), _classNames2))
    }, pane.props.title)));
  }))), panes.map(function (pane) {
    if (pane.props.children === undefined) {
      return null;
    }
    var active = pane.key === activeKey;
    return /*#__PURE__*/React.createElement(ShouldRender, {
      key: pane.key,
      active: active,
      forceRender: pane.props.forceRender,
      destroyOnClose: pane.props.destroyOnClose
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(classPrefix, "-content"),
      style: {
        display: active ? "block" : "none"
      }
    }, pane.props.children));
  })));
};
Tabs.defaultProps = {
  activeLineMode: "fixed",
  stretch: true,
  showSubscript: true
};
Tab.defaultProps = {
  destroyOnClose: false,
  disabled: false,
  forceRender: false
};